import styled from 'styled-components';

/**
 * This component overrides default react-toastify's css variables
 * https://fkhadra.github.io/react-toastify/how-to-style#override-css-variables
 * React toastify comes with 3 predefined themes, light, dark and colored (which is actually a blank theme)
 * All of theme can be customized using these variables and if we need more we'll use other techniques from this page: https://fkhadra.github.io/react-toastify/how-to-style
 * Variables that are set with their default value (as they come from react-toastify) ARE COMMENTED
 */
export const ToasterStyleWrapper = styled.div`
    // use html & instead of :root
    html & {
        /* general toast styles  */
        --toastify-toast-width: 388px;
        /* --toastify-toast-background: #fff; */
        /* --toastify-toast-min-height: 64px; */
        /* --toastify-toast-max-height: 800px; */
        --toastify-font-family: ${({theme}) => theme.font.presets.regular};
        /* --toastify-z-index: 9999; */

        /* Colors used by the toaster */
        /* these seem to be the backgrounds */
        --toastify-color-light: ${({theme}) => theme.colors.backgroundDark}; /* <-- TODO: this should be a light color and the light theme should be used for 777 for the rest the dark theme */
        --toastify-color-dark: ${({theme}) => theme.colors.backgroundDark};
        /* this seems to be text colors and they are set sometimes as icon colors and progress bar colors */
        /* --toastify-color-info: #3498db; */
        /* --toastify-color-success: #07bc0c; */
        /* --toastify-color-warning: #f1c40f; */
        /* --toastify-color-error: #e74c3c; */
        /* I don't know where this is used */
        /* --toastify-color-transparent: rgba(255, 255, 255, 0.7); */

        /* colors used for icons */
        /* --toastify-icon-color-info: var(--toastify-color-info); */
        /* --toastify-icon-color-success: var(--toastify-color-success); */
        /* --toastify-icon-color-warning: var(--toastify-color-warning); */
        /* --toastify-icon-color-error: var(--toastify-color-error); */

        /* text colors for light and dark themes */
        --toastify-text-color-light: ${({theme}) => theme.colors.textLight};
        --toastify-text-color-dark: ${({theme}) => theme.colors.textLight};

        /* Used only for colored theme */
        /* --toastify-text-color-info: #fff; */
        /* --toastify-text-color-success: #fff; */
        /* --toastify-text-color-warning: #fff; */
        /* --toastify-text-color-error: #fff; */

        /* --toastify-spinner-color: #616161; */
        /* --toastify-spinner-color-empty-area: #e0e0e0; */

        /* Used when no type (info, success, warning, error) is provided */
        --toastify-color-progress-light: ${({theme}) => theme.colors.brandPrimary};
        /* Used when no type (info, success, warning, error) is provided */
        --toastify-color-progress-dark: ${({theme}) => theme.colors.brandPrimary};
        /* Used when type (info, success, warning, error) IS provided */
        /* --toastify-color-progress-info: var(--toastify-color-info); */
        /* --toastify-color-progress-success: var(--toastify-color-success); */
        /* --toastify-color-progress-warning: var(--toastify-color-warning); */
        /* --toastify-color-progress-error: var(--toastify-color-error); */

        /* used to control the opacity of the progress trail */
        --toastify-color-progress-bgo: 1;
    }
`;